module.exports = __webpack_public_path__ + "static/media/Amina.4f22866b.jpg";